export default "__VITE_ASSET__BvUwGkbw__"